import { jsxs as d, jsx as n } from "react/jsx-runtime";
import { forwardRef as j } from "react";
import { InputElementTopSection as v } from "../components/input-element-top-section/input-element-top-section.js";
import l from "./select.module.less.js";
const y = (s, o) => {
  if (!o)
    return s;
  const t = [...s];
  return t?.unshift({ value: o, label: o }), t;
}, x = j(
  ({ value: s, items: o, placeholder: t, label: a, isDisabled: m, errorText: c, helperText: p, onChange: r }, u) => {
    const f = (e) => {
      typeof r == "function" && r(e === t ? null : e);
    }, h = y(o, t), b = o.find((e) => e.value === s), i = "select-" + a, N = s === null && t;
    return /* @__PURE__ */ d("div", { className: `${l.wrapper} space-mb-md`, children: [
      /* @__PURE__ */ n(v, { label: a, helperText: p, errorText: c ?? void 0, htmlFor: i }),
      /* @__PURE__ */ n(
        "select",
        {
          ref: u,
          className: [l.select, c ? l.error : ""].join(" "),
          id: i,
          disabled: m,
          value: s === null ? t : s,
          onChange: (e) => f(e.target.value),
          children: h.map((e) => /* @__PURE__ */ n("option", { value: e.value, disabled: e.disabled, children: e.label }, e.value))
        }
      ),
      /* @__PURE__ */ d("label", { className: [l.label].join(" "), htmlFor: i, children: [
        /* @__PURE__ */ n("div", { className: [l.selectButton, N ? l.placeholderDisplayed : ""].join(" "), children: /* @__PURE__ */ n("p", { className: l.triggerValue, children: s === null ? t : b?.label ?? "" }) }),
        /* @__PURE__ */ n("div", { className: l.iconWrapper, children: /* @__PURE__ */ n("span", { className: ["ui-icon-arrow-drop-down", l.icon].join(" ") }) })
      ] })
    ] });
  }
);
x.displayName = "SelectBox";
export {
  x as default
};
